(function () {
  const formWrapper = $('.form__wrapper'),
    accordionHeader = $('[data-accordion-toggle]'),
    accordionHeaderCustom = $('[data-accordion-toggle-custom]'),
    accordionBody = $('[data-accordion-body]'),
    accordionColor = $('.accordion-color'),
    selectedHeader = $('[data-selected-header]'),
    selectedSize = $('[data-selected-size]'),
    selectedLining = $('[data-selected-lining]'),
    selectedRomanDesign = $('[data-roman-selected-design]'),
    selectedRomanFabric = $('[data-roman-selected-fabric]'),
    selectedRomanLining = $('[data-roman-selected-lining]'),
    selectedRomanMount = $('[data-roman-selected-mount]'),
    selectedRomanSize = $('[data-roman-selected-size]'),
    selectedRomanCord = $('[data-roman-selected-cord]'),
    selectedRomanLift = $('[data-roman-selected-lift]'),
    nextStep = $('[data-next-step]');

  accordionHeader.click(function () {
    accordionHeaderUpdates($(this));
  });

  accordionHeaderCustom.click(function () {
    toggleHeader($(this));
  });

  nextStep.click(function () {
    openNextOption($(this));
  });

  const openNextOption = (_this) => {
    const curHeader = _this.parent().prev();
    const nextHeader = _this.parent().parent().next();
    const selectedOption = $('.custom-configurator-image-select-item-active');
    const width = $('#select-width-id option:selected').text();
    const height = $('#select-length-id option:selected').text();

    toggleOptions(_this, curHeader, nextHeader);
    displaySelectedOption(_this, curHeader, selectedOption, width, height);
    displaySelectedRomanOption(_this, curHeader, selectedOption, width, height);
  }

  const toggleOptions = (_this, curHeader, nextHeader) => {
    // close current option
    _this.closest(accordionBody).css('display', 'none');
    curHeader.removeClass('is-open');
    curHeader.addClass('selected-step');
    // open next option
    nextHeader.find(accordionHeader)[0].classList.add('is-open');
    nextHeader.find(accordionBody)[0].style.display = 'block';
  }

  const displaySelectedOption = (_this, curHeader, selectedOption, width, height) => {
    const curText = curHeader[0].innerText;

    if (curText.includes('Header')) {
      selectHeader(selectedOption)
      resetPosition()
    } else if (curText.includes('Size')) {
      selectSize(width, height)
      resetPosition()
    } else if (curText.includes('Lining')) {
      selectLining(selectedOption)
    }
  }

  const resetPosition = () => {
    setTimeout(() => {
      formWrapper.css({
        'overflow-y': 'unset',
        'overflow-x': 'unset'
      })
    }, 100);
  }

  const resetOverflow = () => {
    $(window).scroll(function () {
      formWrapper.css({
        'overflow-y': 'scroll',
        'overflow-x': 'hidden'
      });
    });
  }

  resetOverflow();

  const displaySelectedRomanOption = (_this, curHeader, selectedOption, width, height) => {
    const curText = curHeader[0].innerText;


    if (curText.includes('Design')) {
      selectRomanDesign(selectedOption)
    } else if (curText.includes('Fabric')) {
      selectRomanFabric(selectedOption)
      resetRomanPosition()
    } else if (curText.includes('Lining')) {
      selectRomanLining(selectedOption)
      resetRomanPosition()
    } else if (curText.includes('Mount')) {
      selectRomanMount(selectedOption)
      resetRomanPosition()
    } else if (curText.includes('Size')) {
      selectRomanSize(width, height)
      // resetRomanPosition()
    } else if (curText.includes('Cord')) {
      selectRomanCord(selectedOption)
    } else if (curText.includes('Lift')) {
      selectRomanLift(selectedOption)
    }
  }

  const resetRomanPosition = () => {
    $('html, body').animate({
      scrollTop: formWrapper.offset().top - 1500
    }, 'slow');
  }

  const toggleHeader = (_this) => {
    if (_this[0].className.includes('is-open')) {
      _this.removeClass('is-open');
      _this.next().css("display", "none");
    } else {
      accordionHeader.removeClass('is-open');
      accordionHeader.next().css("display", "none");
      _this.addClass('is-open');
      _this.next().css("display", "block");
    }
  }

  const accordionHeaderUpdates = (_this) => {
    const optionTitle = _this[0].innerText;
    const selectedOption = $('.custom-configurator-image-select-item-active');
    const width = $('#select-width-id option:selected').text();
    const height = $('#select-length-id option:selected').text();

    updateHeaderBG(optionTitle, _this);
    selectCustomAccordion(selectedOption, width, height, optionTitle, _this);
    selectRomanAccordion(selectedOption, width, height, optionTitle, _this);
  }

  const selectCustomAccordion = (selectedOption, width, height, optionTitle, _this) => {
    if (_this[0].className.includes('is-open')) {
      _this.addClass('selected-step');
      if (optionTitle.includes('Header')) {
        selectHeader(selectedOption);
      } else if (optionTitle.includes('Size')) {
        selectHeader(selectedOption);
        selectSize(width, height);
      } else if (optionTitle.includes('Lining')) {
        selectSize(width, height);
        selectLining(selectedOption);
      } else if (optionTitle.includes('Summary')) {
        selectLining(selectedOption);
      }
    }
  }

  const selectRomanAccordion = (selectedOption, width, height, optionTitle, _this) => {
    if (_this[0].className.includes('is-open')) {
      _this.addClass('selected-step');
      if (optionTitle.includes('Design')) {
        selectRomanDesign(selectedOption);
      } else if (optionTitle.includes('Fabric')) {
        selectRomanDesign(selectedOption);
        selectRomanFabric(selectedOption)
      } else if (optionTitle.includes('Lining')) {
        selectRomanFabric(selectedOption);
        selectRomanLining(selectedOption);
      } else if (optionTitle.includes('Mount')) {
        selectRomanLining(selectedOption);
        selectRomanMount(selectedOption);
      } else if (optionTitle.includes('Size')) {
        selectRomanMount(selectedOption);
        selectRomanSize(width, height);
      } else if (optionTitle.includes('Cord')) {
        selectRomanSize(width, height);
        selectRomanCord(selectedOption);
      } else if (optionTitle.includes('Lift')) {
        selectRomanCord(selectedOption);
        selectRomanLift(selectedOption);
      } else if (optionTitle.includes('Summary')) {
        selectRomanLift(selectedOption);
      }
    }
  }

  const updateHeaderBG = (optionTitle, _this) => {
    if (!optionTitle.includes('Color')) accordionColor.addClass('selected-step');
     _this.parent().prev().find(accordionHeader).addClass('selected-step');
  }

  const selectHeader = (option) => selectedHeader.text(`: ${option[0].innerText}`);
  const selectSize = (width, height) => selectedSize.text(`: ${width}" W x ${height}" L`);
  const selectLining = (option) => selectedLining.text(`: ${option[1].innerText}`);
  const selectRomanDesign = (option) => selectedRomanDesign.text(`: ${option[0].innerText}`);
  const selectRomanFabric = (option) => selectedRomanFabric.text(`: ${option[1].dataset.imageSelectItem}`);
  const selectRomanLining = (option) => selectedRomanLining.text(`: ${option[2].dataset.imageSelectItem}`);
  const selectRomanMount = (option) => selectedRomanMount.text(`: ${option[3].dataset.imageSelectItem}`);
  const selectRomanSize = (width, height) => selectedRomanSize.text(`: ${width}" W x ${height}" L`);
  const selectRomanCord = (option) => selectedRomanCord.text(`: ${option[4].dataset.imageSelectItem}`);
  const selectRomanLift = (option) => selectedRomanLift.text(`: ${option[5].dataset.imageSelectItem}`);

})();
